import { useRef } from 'react'
import { Provider } from 'react-redux'
import { makeStore } from '../state/store'
import { checkAuth } from '@/state/auth/auth.slice'

export default function StoreProvider({ children }) {
  const storeRef = useRef()
  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore()

    // Dispatch checkAuth to verify session on app load
    storeRef.current.dispatch(checkAuth())
  }

  return <Provider store={storeRef.current}>{children}</Provider>
}
